import React, { useEffect, useState } from "react";
import { ProductCard } from "./ProductCard";
import { Reveal } from "./Reveal";

// Domyślnie widać tylko PEŁNE rzędy (liczba kolumn zależy od szerokości ekranu).
// Niepełny ostatni rząd pojawia się dopiero po kliknięciu „Pokaż wszystkie".
const INITIAL_COUNT = 12;
const MIN_WIDTH = { sm: 640, md: 768, lg: 1024, xl: 1280 };

// Czyta klasy Tailwind (np. "grid-cols-2 sm:grid-cols-3 lg:grid-cols-4") i zwraca liczbę kolumn dla szerokości ekranu
function columnsFor(width, cols) {
  let result = 1;
  let bestMin = -1;
  for (const token of cols.split(" ")) {
    const m = /^(?:(sm|md|lg|xl):)?grid-cols-([0-9]+)$/.exec(token);
    if (!m) continue;
    const min = m[1] ? MIN_WIDTH[m[1]] : 0;
    if (width >= min && min > bestMin) { bestMin = min; result = parseInt(m[2], 10); }
  }
  return result;
}

function useColumns(cols) {
  const [n, setN] = useState(() => columnsFor(typeof window === "undefined" ? 1024 : window.innerWidth, cols));
  useEffect(() => {
    const update = () => setN(columnsFor(window.innerWidth, cols));
    update();
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, [cols]);
  return n;
}

export function ProductGrid({ products, testid = "product-grid", cols = "grid-cols-2 sm:grid-cols-3 lg:grid-cols-4" }) {
  const [showAll, setShowAll] = useState(false);
  const columns = useColumns(cols);
  if (!products.length) return null;

  const limit = Math.min(products.length, INITIAL_COUNT);
  const fullRows = Math.floor(limit / columns) * columns;
  // mniej produktów niż kolumn — nie da się wypełnić rzędu, pokazujemy wszystkie
  const initial = fullRows > 0 ? fullRows : products.length;
  const shown = showAll ? products : products.slice(0, initial);
  const hidden = products.length - initial;

  return (
    <>
      <div className={`grid gap-4 sm:gap-6 ${cols}`} data-testid={testid}>
        {shown.map((p, i) => (
          <Reveal key={p.id} delay={Math.min(i, 8) * 70}>
            <ProductCard product={p} />
          </Reveal>
        ))}
      </div>
      {hidden > 0 && (
        <div className="mt-10 text-center">
          <button
            data-testid={`${testid}-show-more`}
            onClick={() => setShowAll(!showAll)}
            className="rounded-full border border-cyan-400/40 bg-cyan-400/10 px-8 py-3 font-display text-sm font-bold text-cyan-200 transition-all hover:scale-105 hover:bg-cyan-400/20 active:scale-95"
          >
            {showAll ? "Pokaż mniej" : `Pokaż wszystkie (${products.length})`}
          </button>
        </div>
      )}
    </>
  );
}
